


























































import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { EventBus } from '@/main';

@Component({ name: 'main-nav' })
export default class MainNav extends Vue {
    @Prop({ required: true })
    nodes!: string;

    @Prop({ required: true })
    opened!: boolean;

    @Prop({ default: 0 })
    paddingLeft!: number;

    redirect(action: string | Function) {
        if (action && typeof action === 'string') {
            if (this.$route.path !== action) {
                this.$router.push(action);
            } else {
                EventBus.$emit('refreshView');
            }
        } else if (action && typeof action === 'function') {
            action.apply(this.$parent); // TODO: Hacerlo más elegante (¿mixins? ¿props?)
        }
    }
}
